@if (enableGlobalBanner) {
  <cms-disruptions [disruptions]="collection$ | async" [isGlobalBanner]="true" />
}
